import styled from "styled-components";

export const LoadMoreBtnStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  button {
    padding: 0.5rem;
    border-radius: 5px;
    border: none;
    outline: none;
    cursor: pointer;
    background-color: #0dda51;
    font-size: 1rem;
  }
`;
